import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useCallback } from 'react';

import { useSDK } from '../../../../../app/App';
import { styled } from '../../../../../styled';
import type { Theme } from '../../../../../theme/interface/detailed';
import { CloseIcon } from '../../../../icons/closeIcon';
import { ReplyIcon } from '../../../../icons/replyIcon';
import { ReplyMessagePreview } from './ReplyMessagePreview';

const styles = css`
	display: flex;
	box-sizing: border-box;
	justify-content: space-between;
	align-items: center;

	& i {
		padding-right: 14px;
	}

	& .ncc-reply-close {
		cursor: pointer;
		padding-left: 14px;
		box-sizing: content-box;
		& > path {
			stroke-width: 3;
		}
	}
`;

const Component = observer(({ className = '' }: { className?: string }): ReactElement | null => {
	const { replyMessageStore } = useSDK();
	const onCloseHandler = useCallback(() => {
		replyMessageStore.clearRepliedMessage();
	}, [replyMessageStore]);

	if (typeof replyMessageStore?.repliedMessage === 'object' && replyMessageStore?.repliedMessage) {
		return (
			<div className={className}>
				<ReplyIcon />
				<ReplyMessagePreview message={replyMessageStore.repliedMessage} />
				<CloseIcon className="ncc-reply-close" onClick={onCloseHandler} />
			</div>
		);
	}
	return null;
});

export const ReplyPreview = styled(Component)(
	({
		theme: {
			chat: {
				replyMessage: {
					replyPreviewContainer: { replyCloseIconColor, replyCloseIconSize, ...other },
				},
			},
		},
	}: {
		theme: Theme;
	}) => {
		return {
			...other,
			'& .ncc-reply-close': {
				width: replyCloseIconSize,
				height: replyCloseIconSize,
				'& path': {
					stroke: replyCloseIconColor,
				},
			},
		};
	},
	styles
);
